// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "projects";

export const projectKeys = {
  // Base keys
  all: [collection],
  details: () => [...projectKeys.all, "detail"],
  detail: (id) => [...projectKeys.details(), id],
  coordinators: (id) => [collection, "coordinators", id],
  allocatedSum: (id) => [...projectKeys.all, "allocated", id],
  allApprovedHours: (id) => [...projectKeys.all, "approved", id],
  allLoggedHours: (id) => [...projectKeys.all, "logged", id],
  configAmount: (id) => [...projectKeys.all, "config", id],
  collectedBillables: (id) => [
    ...projectKeys.all,
    "billables",
    "collected",
    id,
  ],
  dates: (id) => [...projectKeys.all, "dates", id],
  expectedBillables: (id) => [...projectKeys.all, "billables", "expected", id],
  pendingBillables: (id) => [...projectKeys.all, "billables", "pending", id],
  cancelledBillables: (id) => [...projectKeys.all, "billables", "cancelled", id],
  details: () => [collection, "detail"],
  activeCount: () => [collection, "active"],
};

export function invalidateProjectQueries() {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection && queryKey[1] === "list",
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

// Additional helper for invalidating all job queries
export function invalidateAllJobQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
